<script setup lang="ts">
/** DR-10 · Download a dataset after its short-lived signed address has been issued. */
import Dialog from '~/components/ui/Dialog.vue'
import Icon from '~/components/ui/Icon.vue'
import ActionButton from '~/components/ui/ActionButton.vue'
import ParamRow from '~/components/inspector/ParamRow.vue'
import StatusCell from '~/components/ui/StatusCell.vue'

withDefaults(defineProps<{
  entity: string
  facts: { label: string; value: string }[]
  phase?: 'idle' | 'issuing' | 'ready' | 'refused'
  problem?: string | null
}>(), { phase: 'idle', problem: null })
const emit = defineEmits<{ close: []; download: [] }>()
const WORD = { idle: '', issuing: 'Issuing address', ready: 'Ready', refused: 'Refused' }
</script>

<template>
  <Dialog title="Download dataset" :meta="entity" :width="480" @close="emit('close')">
    <template #icon><Icon name="download" /></template>
    <div class="flex flex-col gap-[var(--measure-7px)] rounded-md border border-border px-3 py-2.5">
      <ParamRow v-for="fact in facts" :key="fact.label" :label="fact.label" :value="fact.value" />
      <ParamRow v-if="phase !== 'idle'" label="Address"><StatusCell :status="WORD[phase]" /></ParamRow>
    </div>
    <p class="num m-0 text-[length:var(--type-fine)]" :class="phase === 'refused' ? 'text-destructive' : 'text-muted-foreground'">{{ phase === 'refused' ? (problem ?? 'The address could not be issued') : 'The address is short-lived · it opens once, in a new tab' }}</p>
    <template #actions>
      <ActionButton label="Cancel" @click="emit('close')" />
      <ActionButton label="Download" variant="primary" :disabled="phase === 'issuing'" @click="emit('download')"><template #icon><Icon name="download" /></template></ActionButton>
    </template>
  </Dialog>
</template>
